import React, { JSX } from 'react';
import {
  Field,
  Link,
  LinkField,
  Text,
} from '@sitecore-jss/sitecore-jss-nextjs';
import { StyleguideComponentProps } from 'lib/component-props';
import { ItemValue } from 'components/types/ListItem';
import { classNames } from 'assets/utils/helper';
import { getMarginSize } from 'assets/utils/getMarginSize';
import {  useSitecoreContext } from '@sitecore-jss/sitecore-jss-nextjs';

type CTASectionProps = StyleguideComponentProps & {
  fields: {
    MarginSize: {
      fields: {
        heading: {
          value: string;
        };
      };
    };
    Heading: Field<string>;
    HeadingColor: ItemValue;
    Description: Field<string>;
    DescriptionColor: ItemValue;
    CTA: LinkField;
    CTAType: ItemValue;
    Background: ItemValue;
  };
};

const CTASection = (props: CTASectionProps): JSX.Element => {
  if (!props || !props.fields) {
    return <div></div>;
  }

  const marginSize = getMarginSize(
    props?.fields?.MarginSize?.fields?.heading?.value
  );

  const {
    Heading,
    HeadingColor,
    Description,
    DescriptionColor,
    CTA,
    CTAType,
    Background,
  } = props.fields;

  const headingColor = HeadingColor?.name
    ? `heading color-${HeadingColor.name.toLowerCase()}`
    : 'heading';

  const descColor = DescriptionColor?.name
    ? `description color-${DescriptionColor.name.toLowerCase()}`
    : 'description';

  const isOnCall = useSitecoreContext()?.sitecoreContext?.itemPath?.includes('/oncall/');

  return (
    <div
      className={classNames('overhauled cta-section', marginSize)}
      id={`cta-section-${props.rendering?.uid}`}
    >
        <div
              className={`${
                Background?.name
                  ? Background.name == 'bg-color-gradient'
                    ? isOnCall
                      ? 'gradient-bg-oncall-b2b-horizontal'
                      : 'gradient-bg-dark-responsive'
                    : Background?.name
                  : 'bg-primary'
              }`}
            >
        <div className="jss-inner-container inner-vertical-spacing content-wrapper">
          {Heading?.value && (
            <Text tag="h2" className={headingColor} field={Heading} />
          )}
          {Description?.value && (
            <p className={descColor}>{Description?.value}</p>
          )}
          {CTA?.value?.href && (
            <Link
              field={CTA}
              className={
                CTAType
                  ? `cta-btn btn-mobile-fw btn-${CTAType?.name.toLowerCase()} no-icon`
                  : 'cta-btn btn-mobile-fw no-icon'
              }
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default CTASection;
